export class ApiError extends Error {
    constructor(message?: string) {
        super(message);
    }
}

export class CreateError extends ApiError {
    constructor(message?: string) {
        super(message);
    }
}

export class ReadError extends ApiError {
    constructor(message?: string) {
        super(message);
    }
}

export class DownloadError extends ApiError {
    constructor(message?: string) {
        super(message);
    }
}

export class UploadError extends ApiError {
    constructor(message?: string) {
        super(message);
    }
}

export class UpdateError extends ApiError {
    constructor(message?: string) {
        super(message);
    }
}
